export default __webpack_public_path__ + "static/media/earth_green.f5dba22e.svg";